import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TocCountryBased } from './country-update.model';

@Component({
  selector: 'document-country-update',
  template: '<div>no template defined</div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountryUpdateComponent implements OnInit {
  @Input() tocCountryBased: TocCountryBased;
  @Input() uniqueNumber: string;

  constructor() {}

  ngOnInit(): void {}

  /** Get the map from the cell from the array at a given line and column
   * ColumnCount: is the number of column of the cell matrix
   */
  getCellContent(columnCount: number, line: number, column: number) {
    const index = columnCount * line + column;
    if (this.tocCountryBased.cells[index] === null) {
      return new Map();
    }
    return this.tocCountryBased.cells[index].content;
  }

  getAllUuids() {
    let allUuids = '';
    this.tocCountryBased.cells.forEach((cell) => {
      if (cell) {
        Object.keys(cell?.content).forEach((uuid) => {
          allUuids = allUuids + '_' + uuid;
        });
      }
    });
    return allUuids;
  }

  getCountryUuids(columnCount: number, line: number, column: number) {
    let allUuids = '';
    for (let i = 0; i < line; i++) {
      let cell = this.tocCountryBased.cells[i * columnCount + column];
      if (cell) {
        Object.keys(cell?.content).forEach((uuid) => {
          allUuids = allUuids + '_' + uuid;
        });
      }
    }
    return allUuids;
  }

  getPillarUuids(columnCount: number, line: number) {
    let allUuids = '';
    for (let i = 0; i < columnCount; i++) {
      let cell = this.tocCountryBased.cells[line * columnCount + i];
      if (cell) {
        Object.keys(cell?.content).forEach((uuid) => {
          allUuids = allUuids + '_' + uuid;
        });
      }
    }
    return allUuids;
  }
}
